/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';


/**
 * Form translation mixin.
 *
 * Provides additional formatting help for form driven translations.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component
export default class FormTranslation extends Vue {
    /**
     * Format the translation key.
     *
     * @param {string} group
     * @param {string} key
     * @param {string} prefix
     *
     * @returns {string}
     */
    public formatTranslation(group: string, key?: string, prefix: string = ''): string {
        if (undefined === key) {
            return '';
        }

        return `${prefix}.${group.toLowerCase()}.${key.toLowerCase()}`;
    }
}

